import { render, staticRenderFns } from "./amazon-order-list.vue?vue&type=template&id=b592a008&lang=pug&"
import script from "./amazon-order-list.vue?vue&type=script&lang=js&"
export * from "./amazon-order-list.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports